import { render, staticRenderFns } from "./PaginaScadenziario.vue?vue&type=template&id=1f852d36"
import script from "./PaginaScadenziario.vue?vue&type=script&lang=js"
export * from "./PaginaScadenziario.vue?vue&type=script&lang=js"
import style0 from "./PaginaScadenziario.vue?vue&type=style&index=0&id=1f852d36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports